export default __webpack_public_path__ + "static/media/camera.ca49a7b3.svg";